import React from 'react'
import { SnackbarProvider, SnackbarProviderProps } from 'notistack'

const snackbarOptions: SnackbarProviderProps = {
  autoHideDuration: 3000,
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
}

const ReactSnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  return <SnackbarProvider {...snackbarOptions}>{children}</SnackbarProvider>
}

export default ReactSnackbarProvider
